import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'
import '@/assets/css/theme.scss'

import isBnn from '@/config/isBnn'

const studio7 = {
  primary: '#0071e3',
  secondary: '#434242',
  accent: '#8C9EFF',
  error: '#E30000',
  info: '#2196F3',
  success: '#008900',
  warning: '#EBA614',
}

const bnn = {
  primary: '#fd0',
  secondary: '#000000',
  accent: '#8C9EFF',
  error: '#E30000',
  info: '#2196F3',
  success: '#008900',
  warning: '#EBA614',
}

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: false,
    default: 'light',
    disable: false,
    options: {
      cspNonce: undefined,
      customProperties: undefined,
      minifyTheme: undefined,
      themeCache: undefined,
    },
    themes: {
      light: isBnn ? bnn : studio7,
    },
  },
  icons: {
    iconfont: 'mdiSvg',
  },
})
